// Encode/decode plan inputs to/from URL hash for shareable links.

const safeBase64Encode = (str) => {
  // utf8 safe
  return btoa(unescape(encodeURIComponent(str)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

const safeBase64Decode = (b64) => {
  const norm = b64.replace(/-/g, "+").replace(/_/g, "/");
  const pad = norm.length % 4 ? "=".repeat(4 - (norm.length % 4)) : "";
  return decodeURIComponent(escape(atob(norm + pad)));
};

export const encodePlan = (inputs) => {
  try {
    return safeBase64Encode(JSON.stringify(inputs));
  } catch {
    return "";
  }
};

export const decodePlan = (hashStr) => {
  try {
    if (!hashStr) return null;
    const raw = hashStr.startsWith("#") ? hashStr.slice(1) : hashStr;
    if (!raw.startsWith("p=")) return null;
    const payload = raw.slice(2);
    const json = safeBase64Decode(payload);
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const buildShareUrl = (inputs) => {
  const enc = encodePlan(inputs);
  if (typeof window === "undefined") return "";
  // Use the /api/share?p=... route so social platforms can crawl OG meta tags.
  // Backend renders preview card image + redirects humans to the SPA hash URL.
  const origin = window.location.origin;
  return `${origin}/api/share?p=${enc}`;
};

export const readPlanFromUrl = () => {
  if (typeof window === "undefined") return null;
  return decodePlan(window.location.hash);
};
